import { render, staticRenderFns } from "./regTypeFieldVideoRecord.vue?vue&type=template&id=b640261c"
import script from "./regTypeFieldVideoRecord.vue?vue&type=script&lang=js"
export * from "./regTypeFieldVideoRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports